const compatModules = {};import * as Mod1 from "./discourse/admin-anonymous-email-log-route-map";
compatModules["discourse/admin-anonymous-email-log-route-map"] = Mod1;

export * as discourse$admin__anonymous__email__log__route__map$$__module from "./discourse/admin-anonymous-email-log-route-map";
export {
default as discourse$admin__anonymous__email__log__route__map$$default
} from "./discourse/admin-anonymous-email-log-route-map";
import * as Mod2 from "./discourse/controllers/admin-plugins/anonymous-email-log";
compatModules["discourse/controllers/admin-plugins/anonymous-email-log"] = Mod2;

export * as discourse$controllers$admin__plugins$anonymous__email__log$$__module from "./discourse/controllers/admin-plugins/anonymous-email-log";
export {
default as discourse$controllers$admin__plugins$anonymous__email__log$$default
} from "./discourse/controllers/admin-plugins/anonymous-email-log";
import * as Mod3 from "./discourse/models/admin-plugins-anonymous-email-log";
compatModules["discourse/models/admin-plugins-anonymous-email-log"] = Mod3;

export * as discourse$models$admin__plugins__anonymous__email__log$$__module from "./discourse/models/admin-plugins-anonymous-email-log";
export {
default as discourse$models$admin__plugins__anonymous__email__log$$default
} from "./discourse/models/admin-plugins-anonymous-email-log";
import * as Mod4 from "./discourse/routes/admin-plugins/anonymous-email-log";
compatModules["discourse/routes/admin-plugins/anonymous-email-log"] = Mod4;

export * as discourse$routes$admin__plugins$anonymous__email__log$$__module from "./discourse/routes/admin-plugins/anonymous-email-log";
export {
default as discourse$routes$admin__plugins$anonymous__email__log$$default
} from "./discourse/routes/admin-plugins/anonymous-email-log";
import * as Mod5 from "./discourse/templates/admin-plugins/anonymous-email-log";
compatModules["discourse/templates/admin-plugins/anonymous-email-log"] = Mod5;

export * as discourse$templates$admin__plugins$anonymous__email__log$$__module from "./discourse/templates/admin-plugins/anonymous-email-log";
export {
default as discourse$templates$admin__plugins$anonymous__email__log$$default
} from "./discourse/templates/admin-plugins/anonymous-email-log";
export default compatModules;
